<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/l3pUUq/tc-custom/9781528963268.jpg?1705687990195" alt="This image is the cover for the book Lady Bluebell and Her Magical Gardens"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lady Bluebell and Her Magical Gardens
      </h1>
      <p class="bookDescription body article font2">
        <p>In a faraway land lives Lady Bluebell. She is a long way from home and all those things that are familiar to her. Unbeknown to Lady Bluebell, the Fairy of Peace and the Pixie of Colour crept into the pocket of her coat and came here with her. These fairies lived at the bottom of her garden. They created harmony and colour and followed her everywhere. In this faraway land of whispering trees, she has created beauty and serenity which is shown in her kindness to the animals that live in her gardens. Lady Bluebell believes that if you think kind thoughts, nice things will happen, and she wishes to share her gardens and wonderful experiences with you. This book unlocks the mind to create the freedom of imagination and the excitement of her magical world and all its innocence and wonder.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Teresa Biddle
      </h2>
      
      <p class="authorDescription body article">When Teresa was a small child, she lived in an orphanage called The Ark. It was there that she learned to respect and love the animal kingdom and all its beauty. Teresa found nature in the gardens, made friends with the birds and saw smiling faces in the flowers. This gave her the curiosity to find her imaginary fairies. Later, Teresa went to live in Pennsylvania, USA and was inspired by its incredible beauty and wildlife which was similar to her native England. During this time, a letter arrived from a dear friend, addressed to Lady Bluebell. As she opened the letter, pressed bluebells from her garden in England fell into her lap, igniting her imagination and helping her recall her childhood memories, bringing about the story of Lady Bluebell and Her Magical Gardens. As an adult and back in the UK, Teresa enhanced her watercolour skills, embracing her inner child. The paintings within these pages will speak to the hearts of everyone, young and old alike. “Lady Bluebell believes that if you think kind thoughts, nice things will happen. She wishes to share her gardens and wonderful experiences with you,” says Teresa.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a4164b9c